export interface CustomerDataModel {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  nationalId: string;
  employeeId: string;
  address: string;
  postalCode: string;
}

export class columnsModel {
  field: string;
  header: string;
  width: number;

  constructor() {
    this.field = '';
    this.header = '';
    this.width = 10;
  }
}

export class personData {
  userSessionId: string = '';
  customerSessionId: string = '';
  serviceName: string = '';
  urlPattern: string = '';
  apiVersion: string = '';
  clientId: string = '';
  componentName: string = '';
  globalIdentifierId: string = '';
  platformExternalId: string = '';
  platformInternalId: string = '';
  openAccountProcess: boolean = true;
  domain: string = '';
  layoutId: string = "";
  customerType: string = "";
  roleType: string = '';
  securityLevel: string = '0';
}

export interface CallCustomerAttributes {
  attributes: GEN_attributes

}

export class GEN_attributes {
  IS_CS_CUSTOMER_ID_ENCRYPTED?: boolean=false;
  ENC_CS_CUSTOMER_ID?: string='';
  CS_CLIENT_ID?: string='';
  PINV?: string='';
  UDP_GBL_ID?: string='';
  CUSTOMER_TYPE?: any='';
  ROLE_TYPE?: any='';
  CP_APPROVED_EXCPTION_SECURED?: boolean=false;
  CP_INDICATIVE_DATA_SECURED?: boolean=false;
  QUEUE_NAME?: any='';
  CS_AUTH_CD?:string='';
  cimData?:string='N/A';
}

export class InteractionDTO {
  // _id: any;
  externalRefId?: string;
  clientId?: string;
  created?: string;
  system?: string;
  subject?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    //type?: string;
  };
  description?: string; //”Authorized user required info”
  details?: string; //”client partner”
  channel?: string; //"call",
  buckets: any;
  initiated?: string; //”inbound”
  begin?: any; //"2022-11-11 11:21:36",
  end?: any; //"2022-11-11 11:40:36",
  contact?: {
    id?: string;
    name?: string; //“name of primary customer”,
    type?: string;
    phoneNumber?: string; //“phoneNumber of primary customer”,
    emailAddress?: string; //“emailAddress of primary customer”,
    ipAddress?: any;
    role?: string;
  };
  delegate?: {
    name?: string; //“David Sablowski”,
    delegateId?: string; //“@42421”,
    phoneNumber?: string; //“18476177161“,
    emailAddress?: string; //“david.sablowski@alight.com“
  };
}

export class AngularLogObject {
  userId?: string;
  date?: string;
  timestamp?: string;
  clientID?: string;
  globalId?: string;
  usersessionId?: string;
  customersessionId?: string;
  loger?: string;
  level?: string;
  message?: string;
  action?: string;
  containerName?: string;
  applicationType?: string;
  agentId?: string
}
